(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["holiday-gift-landing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.hgl').forEach(function (root) {
  var toggle = root.querySelector('.hgl-option-toggle');
  if (toggle) {
    toggle.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var option = btn.getAttribute('data-option');
        var single = option === 'single';
        toggle.querySelectorAll('button').forEach(function (b) {
          b.setAttribute('aria-selected', String(b.getAttribute('data-option') === option));
        });
        root.querySelectorAll('.hgl-buy-panel').forEach(function (panel) {
          panel.classList.toggle('active', panel.id.indexOf('-' + option + '-') !== -1);
        });
      });
    });
  }

  var galleryMain = root.querySelector('.hgl-gallery-main');
  var thumbs = root.querySelectorAll('.hgl-gallery-thumb');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var i = thumb.getAttribute('data-slide');
      if (galleryMain) {
        galleryMain.querySelectorAll('.hgl-ph-slide').forEach(function (s) {
          s.classList.toggle('active', s.getAttribute('data-slide') === i);
        });
      }
      thumbs.forEach(function (t) { t.classList.toggle('active', t === thumb); });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
